// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ClientePage_containerCuerpo__Qwe41 {
  background-color: white;
}

.ClientePage_divFormulario__EWKKa {
}

.ClientePage_containerFilaBusqueda__6Gsc\\+ {
  display: flex;

  align-items: center;
  padding: 0px;
  width: 100%;
  margin: 0px;
  justify-content: space-between;
}

.ClientePage_titulo__D6LI3 {
  font-weight: bold;
  font-size: 1.2rem;
  color: var(--text-color);
  margin-bottom: 20px;
  justify-self: flex-start;
  text-align: left;
  width: 100%;
  display: flex;
}

.ClientePage_divTodoEnUnaFila__pfnWx {
  display: flex;
  flex-direction: row;
  margin-left: 0px;
}

.ClientePage_divCampos__81IDp {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-content: flex-start;
  justify-content: flex-start;
  justify-items: flex-start;
  margin-left: 10px;
}

.ClientePage_divCamposItem__tmsxB {
  display: flex;
  flex-direction: row;
  margin-left: 0px;
  text-wrap: wrap;
  word-wrap: break-word;
}

.ClientePage_atributo__PtrZM {
  font-size: 0.8rem;
  font-weight: bold;
  text-wrap: nowrap;
  text-align: left;
  color: var(--text-color-claro);
}

.ClientePage_valor__DcZ0L {
  font-size: 0.8rem;
  color: var(--text-color-claro-2);
  margin-left: 5px;
  text-align: left;
  word-wrap: break-word;
  max-width: 100%;
}

.ClientePage_divBotonera__0\\+RV1 {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 20px;
  flex-wrap: wrap;
  gap: 10px;
}

.ClientePage_circleImage__XJ2Pv {
  width: 150px; /* Ajusta el tamaño según tus necesidades */
  height: 150px; /* Asegúrate de que el alto y el ancho sean iguales para un círculo perfecto */
  border-radius: 50%; /* Esto crea el círculo */
  object-fit: cover; /* Asegura que la imagen cubra completamente el espacio sin deformarse */
  margin-right: 0px;
  border-width: 1px;
  border-style: solid;
}

.ClientePage_containerUsuario__OyTfy {
  width: 100%;
  border-radius: 15px;
  border-color: gray;
  border-width: 1px;
  border-style: solid;

  padding: 10px;
  margin: 10px; /* Agrega un poco de margen entre los botones */
}

@media (min-width: 768px) {
  /* Ajusta este valor según tus necesidades */
  .ClientePage_containerGrillaUsuarios__eVG6m {
    flex-direction: row; /* Cambio en la dirección de flex para alinear los elementos en fila */
    flex-wrap: wrap; /* Permite que los elementos se envuelvan en la siguiente línea si no hay espacio */
    justify-content: flex-start; /* Distribuye el espacio alrededor de los elementos */
  }

  .ClientePage_containerUsuario__OyTfy {
    /* Asume que esta es la clase de tus BotonCardComponent */
    flex: 1 1 45%; /* Ajusta la base y la capacidad de crecimiento/reducción para que cada botón tome aproximadamente un tercio del espacio */
    max-width: 45%; /* Asegura que los botones no sean más anchos que el 30% */
    margin: 10px; /* Agrega un poco de margen entre los botones */
  }

  .ClientePage_circleImage__XJ2Pv {
    width: 30%; /* Ajusta el tamaño según tus necesidades */
    height: auto; /* Asegúrate de que el alto y el ancho sean iguales para un círculo perfecto */
    border-radius: 50%; /* Esto crea el círculo */
    object-fit: cover; /* Asegura que la imagen cubra completamente el espacio sin deformarse */

    border-width: 1px;
    border-style: solid;
  }
}

@media (min-width: 1100px) {
  .ClientePage_containerUsuario__OyTfy {
    /* Asume que esta es la clase de tus BotonCardComponent */
    flex: 1 1 30%; /* Ajusta la base y la capacidad de crecimiento/reducción para que cada botón tome aproximadamente un tercio del espacio */
    max-width: 28%; /* Asegura que los botones no sean más anchos que el 30% */
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/principal/panel/cliente/ClientePage.module.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;AACzB;;AAEA;AACA;;AAEA;EACE,aAAa;;EAEb,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;EACnB,wBAAwB;EACxB,gBAAgB;EAChB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,2BAA2B;EAC3B,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,YAAY,EAAE,2CAA2C;EACzD,aAAa,EAAE,8EAA8E;EAC7F,kBAAkB,EAAE,yBAAyB;EAC7C,iBAAiB,EAAE,wEAAwE;EAC3F,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;;EAEnB,aAAa;EACb,YAAY,EAAE,+CAA+C;AAC/D;;AAEA;EACE,4CAA4C;EAC5C;IACE,mBAAmB,EAAE,sEAAsE;IAC3F,eAAe,EAAE,mFAAmF;IACpG,2BAA2B,EAAE,qDAAqD;EACpF;;EAEA;IACE,yDAAyD;IACzD,aAAa,EAAE,0HAA0H;IACzI,cAAc,EAAE,0DAA0D;IAC1E,YAAY,EAAE,+CAA+C;EAC/D;;EAEA;IACE,UAAU,EAAE,2CAA2C;IACvD,YAAY,EAAE,8EAA8E;IAC5F,kBAAkB,EAAE,yBAAyB;IAC7C,iBAAiB,EAAE,wEAAwE;;IAE3F,iBAAiB;IACjB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,yDAAyD;IACzD,aAAa,EAAE,0HAA0H;IACzI,cAAc,EAAE,0DAA0D;EAC5E;AACF","sourcesContent":[".containerCuerpo {\n  background-color: white;\n}\n\n.divFormulario {\n}\n\n.containerFilaBusqueda {\n  display: flex;\n\n  align-items: center;\n  padding: 0px;\n  width: 100%;\n  margin: 0px;\n  justify-content: space-between;\n}\n\n.titulo {\n  font-weight: bold;\n  font-size: 1.2rem;\n  color: var(--text-color);\n  margin-bottom: 20px;\n  justify-self: flex-start;\n  text-align: left;\n  width: 100%;\n  display: flex;\n}\n\n.divTodoEnUnaFila {\n  display: flex;\n  flex-direction: row;\n  margin-left: 0px;\n}\n\n.divCampos {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  align-content: flex-start;\n  justify-content: flex-start;\n  justify-items: flex-start;\n  margin-left: 10px;\n}\n\n.divCamposItem {\n  display: flex;\n  flex-direction: row;\n  margin-left: 0px;\n  text-wrap: wrap;\n  word-wrap: break-word;\n}\n\n.atributo {\n  font-size: 0.8rem;\n  font-weight: bold;\n  text-wrap: nowrap;\n  text-align: left;\n  color: var(--text-color-claro);\n}\n\n.valor {\n  font-size: 0.8rem;\n  color: var(--text-color-claro-2);\n  margin-left: 5px;\n  text-align: left;\n  word-wrap: break-word;\n  max-width: 100%;\n}\n\n.divBotonera {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  margin-top: 20px;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.circleImage {\n  width: 150px; /* Ajusta el tamaño según tus necesidades */\n  height: 150px; /* Asegúrate de que el alto y el ancho sean iguales para un círculo perfecto */\n  border-radius: 50%; /* Esto crea el círculo */\n  object-fit: cover; /* Asegura que la imagen cubra completamente el espacio sin deformarse */\n  margin-right: 0px;\n  border-width: 1px;\n  border-style: solid;\n}\n\n.containerUsuario {\n  width: 100%;\n  border-radius: 15px;\n  border-color: gray;\n  border-width: 1px;\n  border-style: solid;\n\n  padding: 10px;\n  margin: 10px; /* Agrega un poco de margen entre los botones */\n}\n\n@media (min-width: 768px) {\n  /* Ajusta este valor según tus necesidades */\n  .containerGrillaUsuarios {\n    flex-direction: row; /* Cambio en la dirección de flex para alinear los elementos en fila */\n    flex-wrap: wrap; /* Permite que los elementos se envuelvan en la siguiente línea si no hay espacio */\n    justify-content: flex-start; /* Distribuye el espacio alrededor de los elementos */\n  }\n\n  .containerUsuario {\n    /* Asume que esta es la clase de tus BotonCardComponent */\n    flex: 1 1 45%; /* Ajusta la base y la capacidad de crecimiento/reducción para que cada botón tome aproximadamente un tercio del espacio */\n    max-width: 45%; /* Asegura que los botones no sean más anchos que el 30% */\n    margin: 10px; /* Agrega un poco de margen entre los botones */\n  }\n\n  .circleImage {\n    width: 30%; /* Ajusta el tamaño según tus necesidades */\n    height: auto; /* Asegúrate de que el alto y el ancho sean iguales para un círculo perfecto */\n    border-radius: 50%; /* Esto crea el círculo */\n    object-fit: cover; /* Asegura que la imagen cubra completamente el espacio sin deformarse */\n\n    border-width: 1px;\n    border-style: solid;\n  }\n}\n\n@media (min-width: 1100px) {\n  .containerUsuario {\n    /* Asume que esta es la clase de tus BotonCardComponent */\n    flex: 1 1 30%; /* Ajusta la base y la capacidad de crecimiento/reducción para que cada botón tome aproximadamente un tercio del espacio */\n    max-width: 28%; /* Asegura que los botones no sean más anchos que el 30% */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"containerCuerpo": `ClientePage_containerCuerpo__Qwe41`,
	"divFormulario": `ClientePage_divFormulario__EWKKa`,
	"containerFilaBusqueda": `ClientePage_containerFilaBusqueda__6Gsc+`,
	"titulo": `ClientePage_titulo__D6LI3`,
	"divTodoEnUnaFila": `ClientePage_divTodoEnUnaFila__pfnWx`,
	"divCampos": `ClientePage_divCampos__81IDp`,
	"divCamposItem": `ClientePage_divCamposItem__tmsxB`,
	"atributo": `ClientePage_atributo__PtrZM`,
	"valor": `ClientePage_valor__DcZ0L`,
	"divBotonera": `ClientePage_divBotonera__0+RV1`,
	"circleImage": `ClientePage_circleImage__XJ2Pv`,
	"containerUsuario": `ClientePage_containerUsuario__OyTfy`,
	"containerGrillaUsuarios": `ClientePage_containerGrillaUsuarios__eVG6m`
};
export default ___CSS_LOADER_EXPORT___;
